<template>
  <v-container>
    <v-list light>
      <template v-if="diaries.length > 0">
        <template v-for="diary in diaries">
          <v-list-tile :key="diary.id" :to="'/diary/' + diary.id">
            {{ diary.date }} - {{ diary.title }}
          </v-list-tile>
        </template>
      </template>
      <template v-else>
        <v-list-tile>
          No diary entries
        </v-list-tile>
      </template>
    </v-list>

    <v-btn
      light
      absolute
      bottom
      right
      fab
      to="/diary/new"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    diaries: []
  }),
  mounted: function () {
    var _this = this
    this.axios.get('/diaries')
      .then(function (res) {
        // Format our creation date
        _this.diaries = res.data.map(function (v) {
          let d = _this.$root.parseApiDateTimeString(v.created_at)
          v.date = d.toLocaleDateString()

          return v
        })
      })
      .catch(this.$root.apiErrorHandler())
  }
}
</script>
